import { MutationFunction } from "@tanstack/react-query";

import { api } from "#app/http/api";
import { ClientDto } from "#modules/clients/infra/Client.dto";
import { UpdateClientDto } from "#modules/clients/infra/UpdateClient.dto";

export const updateClient: MutationFunction<
  ClientDto | null,
  { id: string; client: UpdateClientDto }
> = async ({ id, client }) => {
  const payload = {
    ...client,
  };

  const response = await api.clients.update.mutation({
    body: payload,
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
